import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

export const unauthenticatedGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const oktaAuth = inject(OKTA_AUTH) as OktaAuth;

  const isAuthenticated = await oktaAuth.isAuthenticated();

  if (isAuthenticated) {
    router.navigate(['/home']);
    return false;
  }

  return true;
};
